<iframe
    id="extFrame"
    src="https://mediabird.co.in/vijay_kakra/"
    width="100%"
    height="800px"
    style="border:none;">
</iframe>
